module.exports = __webpack_public_path__ + "img/partner-new-icon7.5717ab54.svg";